export default __webpack_public_path__ + "static/media/eye.726cf0fd.svg";